import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';

export const useScrollCheck = (): {
  isScrolling: MutableRefObject<boolean>;
  reloadPreviewRef: MutableRefObject<(() => void) | undefined>;
} => {
  const isScrolling = useRef(false);
  const timerRef = useRef<NodeJS.Timeout>();
  const reloadPreviewRef = useRef<() => void>();

  useEffect(() => {
    const scrollableElement = document.getElementById('wizard-scrollable');
    if (scrollableElement === null) return;
    const onScroll = () => {
      isScrolling.current = true;
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        isScrolling.current = false;
        if (typeof reloadPreviewRef.current === 'function') {
          reloadPreviewRef.current();
          reloadPreviewRef.current = undefined;
        }
      }, 200);
    };
    scrollableElement.addEventListener('scroll', onScroll);

    return () => scrollableElement.removeEventListener('scroll', onScroll);
  }, []);

  return { isScrolling, reloadPreviewRef };
};
